export default "__VITE_ASSET__999bed87__"